import api from "./api";

export const putCancelBooking = async (id) => {
  return api
    .put({
      endpoint: `/booking/own/cancel/${id}`,
      port: process.env.REACT_APP_PORT_BOOK,
    })
    .then((res) => res.data)
    .catch((err) => err.response.data);
};
